export enum BuildParametersKindTab {
  PARAMETERS = 'parameters',
  STATISTICS = 'statistics',
}
